 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/cover'
 import XHTMLHALFTITLE from '@/components/xhtml/halftitle'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTMLGROVEATLANTICLITHUB from '@/components/xhtml/grove-atlantic-lithub'
 import XHTMLTITLE from '@/components/xhtml/title'
 import XHTMLCOPYRIGHT from '@/components/xhtml/copyright'
 import XHTMLCONTENTS from '@/components/xhtml/contents'
 import XHTMLINTRO from '@/components/xhtml/intro'
 import XHTMLPRAC from '@/components/xhtml/prac'
 import XHTMLCH01 from '@/components/xhtml/ch01'
 import XHTMLCH01A from '@/components/xhtml/ch01a'
 import XHTMLCH02 from '@/components/xhtml/ch02'
 import XHTMLCH03 from '@/components/xhtml/ch03'
 import XHTMLCH04 from '@/components/xhtml/ch04'
 import XHTMLCH05 from '@/components/xhtml/ch05'
 import XHTMLCH06 from '@/components/xhtml/ch06'
 import XHTMLCH07 from '@/components/xhtml/ch07'
 import XHTMLCH08 from '@/components/xhtml/ch08'
 import XHTMLCH09 from '@/components/xhtml/ch09'
 import XHTMLCH10 from '@/components/xhtml/ch10'
 import XHTMLCH11 from '@/components/xhtml/ch11'
 import XHTMLCH12 from '@/components/xhtml/ch12'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTMLBACK01 from '@/components/xhtml/back01'
 import XHTMLBRUNETTIS_VENICE_ADDCARDS from '@/components/xhtml/Brunettis_Venice_addcards'
 import XHTMLEXCERPT_TITLE from '@/components/xhtml/Excerpt_title'
 import XHTMLEXCERPT_CH_01 from '@/components/xhtml/Excerpt_ch_01'
 import XHTMLEXCERPT_CH_02 from '@/components/xhtml/Excerpt_ch_02'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/cover",
 			"name" : "xhtml/cover",
 			"component" : XHTMLCOVER
 		},
 		{
 			"path" : "/xhtml/halftitle",
 			"name" : "xhtml/halftitle",
 			"component" : XHTMLHALFTITLE
 		},
 		{
 			"path" : "/xhtml/love_1",
 			"name" : "xhtml/love_1",
 			"component" : XHTMLLOVE_1
 		},
 		{
 			"path" : "/xhtml/grove-atlantic-lithub",
 			"name" : "xhtml/grove-atlantic-lithub",
 			"component" : XHTMLGROVEATLANTICLITHUB
 		},
 		{
 			"path" : "/xhtml/title",
 			"name" : "xhtml/title",
 			"component" : XHTMLTITLE
 		},
 		{
 			"path" : "/xhtml/copyright",
 			"name" : "xhtml/copyright",
 			"component" : XHTMLCOPYRIGHT
 		},
 		{
 			"path" : "/xhtml/contents",
 			"name" : "xhtml/contents",
 			"component" : XHTMLCONTENTS
 		},
 		{
 			"path" : "/xhtml/intro",
 			"name" : "xhtml/intro",
 			"component" : XHTMLINTRO
 		},
 		{
 			"path" : "/xhtml/prac",
 			"name" : "xhtml/prac",
 			"component" : XHTMLPRAC
 		},
 		{
 			"path" : "/xhtml/ch01",
 			"name" : "xhtml/ch01",
 			"component" : XHTMLCH01
 		},
 		{
 			"path" : "/xhtml/ch01a",
 			"name" : "xhtml/ch01a",
 			"component" : XHTMLCH01A
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js